<template>
  <div class="courseware-list">
    <div class="ruleForm-list">
      <el-form ref="ruleForm" label-width="100px" :model="ruleForm">
        <el-form-item
          label="课件名称："
          prop="name"
          required
          style="margin-bottom: 35px"
        >
          <el-input
            v-model="ruleForm.name"
            style="width: 30%"
            :disabled="true"
            placeholder="请在左侧选择具体章节"
          ></el-input>
          <span class="btn">
            <el-button type="primary" @click="handleSave">确认新增</el-button>

            <el-button @click="$router.push('/prepareLessons/myLessons')"
              >取消</el-button
            >
          </span>
          <el-dialog
            title="是否允许协同备课"
            :visible.sync="dialogVisible"
            width="22%"
            :before-close="handleClose"
          >
            <span class="content"
              >是否允许本校其他老师协同备课（允许后，其他老师可对分享后的课件进行编辑）</span
            >
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="dialogVisible = false"
                >协同备课</el-button
              >
              <el-button @click="dialogVisible = false">仅共享</el-button>
            </span>
          </el-dialog>
        </el-form-item>
        <el-form-item label="备课类型：" style="margin-top: 20px">
          <div class="data-list">
            <div
              class="btnlist"
              v-for="(item, index) in allList"
              :class="[isActive === index ? 'active' : '']"
              :key="index"
              @click="clickTab(item, index)"
            >
              {{ item.title }}
            </div>
          </div>
        </el-form-item>

        <el-form-item
          label="共享类型："
          style="margin-top: 20px"
          v-if="issharetype"
        >
          <div class="data-list">
            <div
              class="btnlist"
              v-for="(item, index) in shareList"
              :class="[isActive1 === index ? 'active' : '']"
              :key="index"
              @click="clickTab1(item, index)"
            >
              {{ item.title }}
            </div>
          </div>
        </el-form-item>
        <div class="line"></div>
        <el-form-item label="添加素材：">
          <el-button type="danger" @click="reveal">添加素材</el-button>
          <resourcePool
            v-if="library"
            @repository="repository"
            @resourceAct="resourceAct"
          ></resourcePool>
        </el-form-item>

        <el-form-item label="上传列表：" class="remarks">
          <div class="liststyle">
            <div
              v-for="(item, index) in resourcelist"
              :key="index"
              class="listli"
            >
              <!-- {{ index + 1 }}、 -->
              {{ item.file_name }}
              <div
                class="fr deleteicon"
                style="margin-right: 10px; cursor: pointer"
                @click="handleDel(item, index)"
              >
                <i class="el-icon-close"></i>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div style="margin-left: 100px"></div>
  </div>
</template>
<script>
import URL from "@/api/index.js";
import axios from "axios";
import VueEvent from "@/model/VueEvent";
import uploadfile from "@/components/prepareLessons/uploadFile";
import resourcePool from "@/components/prepareLessons/resourcePool";
import $ from "jquery";

export default {
  data() {
    return {
      fmttype: [
        { fmttype_id: "0", fmttype_name: "全部" },
        { fmttype_id: "11", fmttype_name: "文档" },
        { fmttype_id: "22", fmttype_name: "图片" },
        { fmttype_id: "33", fmttype_name: "音频" },
        { fmttype_id: "44", fmttype_name: "视频" },
        { fmttype_id: "55", fmttype_name: "幻灯片" },
        { fmttype_id: "66", fmttype_name: "其他" },
      ],
      restype: [
        { restype_id: "0", restype_name: "全部" },
        { restype_id: "0101", restype_name: "教案" },
        { restype_id: "0102", restype_name: "课件" },
        { restype_id: "0301", restype_name: "同步课程" },
        { restype_id: "0103", restype_name: "学案" },
        { restype_id: "0104", restype_name: "素材" },
        { restype_id: "0203", restype_name: "习题" },
        { restype_id: "0105", restype_name: "电子课本" },
      ],
      pre_type: [
        { id: "1", name: "云资源" },
        { id: "2", name: "校本资源" },
        { id: "3", name: "我的资源" },
      ],
      radio: "2",
      formatypearr: "",
      aliyunOssToken: "",
      isone: true,
      resourcelist: [],
      formatypearr: "",
      aliyunOssToken: "",
      isclick: false,
      isone: true,
      dialogVisible: false,
      // 库弹框
      library: false,
      content1: null,
      content2: null,
      isActive: 0,
      isActive1: 0,
      sourtype: "3",
      sourtype1: "0",
      type1: "公开",
      type2: "仅共享",
      addfiledata: {
        cptid: "",
        fileurl: "",
        token: "",
        name: "",
      },
      editorOption: {},
      textarea: null,
      shareList: [
        {
          title: "仅共享",
        },
      ],
      allList: [
        {
          title: "公开",
        },
        {
          title: "加密",
        },
        {
          title: "校内共享",
        },
      ],
      ruleForm: {
        name: null,
      },
      issharetype: true,
      fileList: [],
      fileact: {},
      bookid: "d545aCss",
      gradeid: 1,
      subjectid: 1,
    };
  },
  components: { uploadfile, resourcePool },
  mounted() {
    localStorage.setItem("pre_type1", JSON.stringify(this.type1));
    localStorage.setItem("pre_type2", JSON.stringify(this.type2));
    this.isEdit = null;
    VueEvent.$on("tree", (data) => {
      // console.log(data);
      this.addfiledata.cptid = data.chapter_id;
      localStorage.setItem("cptid", JSON.stringify(data.chapter_id));
      this.ruleForm.name = data.chapter_name;
    });
  },
  methods: {
    reveal() {
       if(this.resourcelist.length!=0){
        this.library = false;
        this.$message({
          message: "已有上传文件",
        });
        return false
      }
      // if (this.addfiledata.cptid.length < 12) {
      if (!this.ruleForm.name) {
        this.$message({
          message: "请先选择具体的章节",
        });
        this.library = false;
      } else {
        this.library = true;
      }
    },
    repository(val) {
      this.library = val;
    },
    resourceAct(val) {
      // console.log(val);
      var objectlist = {};
      if (val.file_name) {
        objectlist.file_name = val.file_name;
        objectlist.file_id = val.file_id;
        objectlist.download_url = val.download_url;
        objectlist.file_format = val.fmttype_id;
        objectlist.file_type = val.restype_id;
        objectlist.resource_type = val.type;
        this.resourcelist.push(objectlist);
      }
    },
    clickTab(item, index) {
      localStorage.setItem("pre_type1", JSON.stringify(item.title));
      if (index == 0) {
        this.issharetype = true;
        this.sourtype = "3";
        this.shareList = [{ title: "仅共享" }];
        this.sourtype1 = "0";
        this.isActive1 = 0;
      } else if (index == 1) {
        this.issharetype = false;
        this.sourtype = "1";
        this.shareList = [{ title: "仅共享" }];
        this.sourtype1 = "";
        this.isActive1 = 0;
      } else {
        this.issharetype = true;
        this.sourtype = "2";
        this.shareList = [
          {
            title: "仅共享",
          },
          {
            title: "协同备课",
          },
        ];
      }

      this.isActive = index;
    },
    clickTab1(item, index) {
      localStorage.setItem("pre_type2", JSON.stringify(item.title));
      this.sourtype1 = index;
      this.isActive1 = index;
    },
    handleClose(done) {
      this.dialogVisible = false;
    },
    handleDel(item, index) {
      // console.log(item, index);
      this.resourcelist.splice(index, 1);
      // console.log(this.resourcelist);
    },
    // 上传备课资源
    handleSave() {
      if (this.resourcelist.length == 0) {
        this.$message({
          message: "请添加要上传的备课文件",
        });
        return false;
      }
      this.gradeid = localStorage.getItem("zjgradeCopy");
      this.subjectid = localStorage.getItem("zjsidCopy");
      this.bookid = JSON.parse(localStorage.getItem("chapterid"));
      var data = {
        token: JSON.parse(localStorage.getItem("loginInfo")).token,
        lesson_name: this.ruleForm.name,
        school_id: JSON.parse(localStorage.getItem("loginInfo")).school_id,
        le_type: this.sourtype,
        content: JSON.stringify(this.resourcelist),
        grade_id: this.gradeid,
        subject_id: this.subjectid,
        tag_info: JSON.stringify({
          book_id: this.bookid,
          chapter_id: this.addfiledata.cptid,
          chapter_name: this.ruleForm.name,
        }),
        share_type: this.sourtype1, //共享or协同
      };
      this.$post(URL.getAddlesson, data).then((res) => {
        // 新增成功
        if (res.state == 0) {
          // 新增备课数据上报
          this.resourcelist.forEach((item) => {
            delete item.download_url;
            this.fmttype.forEach((item1) => {
              if (item.file_format == item1.fmttype_id) {
                item.file_format = item1.fmttype_name;
              }
            });
            this.restype.forEach((item2) => {
              if (item.file_type == item2.restype_id) {
                item.file_type = item2.restype_name;
              }
            });
            this.pre_type.forEach((item3) => {
              if (item.resource_type == item3.id) {
                item.resource_type = item3.name;
              }
            });
          });
          var hhh = JSON.parse(localStorage.getItem("loginInfo"));
          this.getRecordRjw(hhh);

          this.$message({
            message: res.msg,
            type: "success",
          });
          this.$router.push("/prepareLessons/myLessons");
        } else {
          this.$message({
            message: res.msg,
          });
        }
      });
    },
    // 搜索数据上报
    getRecordRjw(hh) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入我的备课
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "preparelessons_added",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了我的备课的新增备课功能",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("prepare_traceid")),
            grade_id: JSON.parse(localStorage.getItem("zjgradeCopy")),
            grade_name: JSON.parse(localStorage.getItem("data_nianji")),
            subject_id: JSON.parse(localStorage.getItem("zjsidCopy")),
            subject_name: JSON.parse(localStorage.getItem("data_kemu")),
            textbook_name: JSON.parse(localStorage.getItem("data_zjname")),
            courseware_name: JSON.parse(localStorage.getItem("pre_zjname")),
            preparelessons_type: JSON.parse(localStorage.getItem("pre_type1")),
            share_type:
              JSON.parse(localStorage.getItem("pre_type1")) == "加密"
                ? ""
                : JSON.parse(localStorage.getItem("pre_type2")),
            fodder_list: this.resourcelist,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.courseware-list {
  width: 898px;
  background-color: #ffffff;
  padding: 20px 0px 30px;
  margin-bottom: 50px;
  box-shadow: 0px 0px 6px 0px rgba(200, 200, 200, 0.47);
  .ruleForm-list {
    .line {
      width: 821px;
      height: 1px;
      background-color: #f2f2f2;
      margin: 0px 30px 20px 30px;
    }
  }
}
.btn {
  margin-left: 320px;
}
.upload-demo {
  width: 64% !important;
  display: inline-block;
  margin-left: 30px;
}
.el-upload__tip {
  margin-left: 10px;
}
.data-list {
  display: flex;
  .btnlist {
    width: 80px;
    height: 30px;
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    cursor: pointer;
  }
}
.active {
  color: #fff !important;
  background-color: #409eff !important;
  border-color: #409eff !important;
  cursor: pointer;
}
.qtn {
  width: 56px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: #409eff;
  background-color: #fff;
  border-color: #409eff;
  border: 1px solid #409eff;
  border-radius: 3px;
  display: inline-block;
  margin-left: 10px;
  cursor: pointer;
}
.quill-editor {
  height: 200px;
}
.el-form-item {
  margin-bottom: 12px;
}
.remarks {
  margin-bottom: 20px;
}
.upload {
  margin: 30px 0px;
}
.plan-design {
  margin-top: 30px;
}
.content {
  font-size: 13px;
  color: #777777;
}
.collectDialog {
  border: 1px #eeeeee solid;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
  position: relative;
  padding: 15px 0;
  padding-left: 60px;
  margin-bottom: 10px;
  span {
    margin-right: 80px;
  }
  .list-logo {
    width: 60px;
    height: 60px;
    position: absolute;
    left: 0px;
    bottom: 6px;
  }
}
.collectDialog:hover {
  border: 1px #5d98f0 solid;
}
.active1 {
  border: 1px #5d98f0 solid;
}

.liststyle {
  border: 1px solid #ececec;
  // min-height: 100px;
  min-height: 50px;
  margin-right: 20px;
  padding: 10px;
  border-radius: 4px;
  .listli {
    // border-bottom: 1px solid #f8f8f8;
    margin-bottom: 6px;
    padding-left: 10px;
  }
  .deleteicon {
    i:hover {
      color: rgb(42, 134, 240);
    }
  }
}
</style>